import { Component, Output, EventEmitter } from '@angular/core';
import { StaticText } from '@project_app/config/static.text';
import { BaseComponent } from '@core/components/base/base.component';
import { environment } from '@environment';
import { GtmService } from '@app/core/services/analytics/gtm.service';

@Component({
    selector: 'app-smart-banner',
    templateUrl: './smart-banner.component.html',
    styleUrls: ['./smart-banner.component.scss'],
    standalone: true
})
export class SmartBannerComponent extends BaseComponent {

	staticText: any = StaticText;
	@Output() closeDialog = new EventEmitter();

	constructor(
		private gtmService: GtmService
	) {
		super();
	}

	close() {
		this.closeDialog.emit();
	}

	install() {
		this.gtmService.logEventTracking("home_page", "download_app", "app_banner");
		const store_link = this.isAndroid ? environment.links.store.google : environment.links.store.apple;
		window.open(store_link, '_blank');
	}
}
